import { FormControlLabel, IconButton, Tooltip } from "@material-ui/core";
import MaterialTable from "material-table";
import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import PointersLine from "../Loaders/PointersLine/PointersLine";
import { GeneralStyle, useStyles } from "./EmailTemplateList.styled";
import ViewControlMenu from "../ViewControlMenu/ViewControlMenu";
import { AntSwitch } from "../../helpers/antSwitch";
import TablePagination from "@material-ui/core/TablePagination";
import moment from "moment";
import { EditTwoTone } from "@material-ui/icons";
import { theme as themeConfig } from "../../themes/themes";

const EmailTemplateList = ({
  dataList,
  loadingEmails,
  errorEmails,
  showCards,
  setShowCards,
  anchorEl,
  setAnchorEl,
  anchorSelected,
  setAnchorSelected,
  titleOfTable,
  toggleChecked,
  handleClickActions,
  handleEditEmail,
  handleCloseActions,
  setOpenDeleteModal,
}) => {
  const classes = useStyles();
  const [dataPaginated, setDataPaginated] = useState([]);
  const rowsPerPageList = [5, 10, 20];
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const tablePaginationListView = (props) => {
    const computedProps = { ...props };
    computedProps.style = {
      ...(computedProps?.style ?? {}),
      borderBottom: "0px",
    };
    return (
      <>
        <div style={{ display: "flex", marginTop: "1rem" }}>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <table>
              <tbody>
                <tr>
                  <TablePagination {...computedProps} />
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  };

  useEffect(() => {
    let startIndex = rowsPerPage * currentPage;
    setDataPaginated(dataList.slice(startIndex, startIndex + rowsPerPage));
  }, [rowsPerPage, dataList, currentPage]);

  return (
    <GeneralStyle>
      {loadingEmails && !errorEmails && (
        <Row>
          <Col md="12" className="d-flex justify-content-center mt-5">
            <PointersLine color={themeConfig.button.primary} />
          </Col>
        </Row>
      )}
      {!loadingEmails && errorEmails && (
        <Row>
          <Col md="12" className="d-flex justify-content-center mt-5">
            <h1>Error :(</h1>
          </Col>
        </Row>
      )}
      {!loadingEmails && !errorEmails && (
        <div style={{ padding: "1rem" }}>
          {!showCards && (
            <MaterialTable
              style={{ boxShadow: "none" }}
              title={titleOfTable}
              columns={[
                {
                  title: "Name",
                  field: "name",
                  type: "string",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "Description",
                  field: "description",
                  type: "string",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "Country",
                  field: "countryName",
                  type: "string",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                  render: (rowData) =>
                    rowData.allCountries ? "All" : rowData.countryName,
                },
                {
                  title: "Creation Date",
                  field: "createDate",
                  type: "string",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                  render: (rowData) =>
                    moment(rowData.createDate).format("YYYY-MM-DD"),
                },
                {
                  title: "Disable",
                  field: "recordState",
                  type: "string",
                  sorting: false,
                  cellStyle: {
                    padding: "0px 16px",
                  },
                  render: (rowData) =>
                    rowData?.recordState && (
                      <FormControlLabel
                        control={
                          <AntSwitch
                            size="small"
                            checked={
                              String(rowData?.recordState).toUpperCase() === "ACTIVE" ? true : false
                            }
                            onChange={() => toggleChecked(rowData)}
                          />
                        }
                      />
                    ),
                },
                {
                  title: "Actions",
                  field: "actions",
                  sorting: false,
                  cellStyle: {
                    padding: "0px 16px",
                  },
                  render: (rowData) =>
                    rowData.idEmailTemplate && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Tooltip title="Edit">
                          <IconButton
                            className={classes.active}
                            onClick={() => {
                              setAnchorEl(null);
                              setAnchorSelected(null);
                              handleEditEmail(rowData);
                            }}
                          >
                            <EditTwoTone />
                          </IconButton>
                        </Tooltip>
                      </div>
                    ),
                },
              ]
                .map((item) => ({ ...item }))
                .filter((item) => {
                  return item.title !== "";
                })}
              data={dataList}
              actions={[
                {
                  icon: "view_list",
                  tooltip: "View List",
                  isFreeAction: true,
                  iconProps: { color: showCards ? "secondary" : "primary" },
                  onClick: (event) => {
                    setShowCards(false);
                  },
                },
                {
                  icon: "view_module",
                  tooltip: "View Cards",
                  isFreeAction: true,
                  iconProps: { color: showCards ? "primary" : "secondary" },
                  onClick: (event) => {
                    setShowCards(true);
                  },
                },
              ]}
              options={{
                maxBodyHeight: 450,
                headerStyle: {
                  zIndex: 1,
                  fontWeight: "bold",
                },
                cellStyle: {
                  padding: "5px 10px",
                },
              }}
              components={{
                Pagination: tablePaginationListView,
              }}
            ></MaterialTable>
          )}
          {showCards && (
            <ViewControlMenu
              className="mt-5"
              identity={"email-template-list"}
              title={titleOfTable}
              showCards={showCards}
              setShowCards={setShowCards}
              list={dataPaginated}
              isAgent={false}
              toggleChecked={toggleChecked}
              handleClickActions={handleClickActions}
              anchorSelected={anchorSelected}
              anchorEl={anchorEl}
              handleCloseActions={handleCloseActions}
              handleEditEmail={handleEditEmail}
              setAnchorEl={setAnchorEl}
              setAnchorSelected={setAnchorSelected}
              setOpenDeleteModal={setOpenDeleteModal}
              showSearchBar={true}
            />
          )}
          {showCards &&
            (dataList.length > 0 ? (
              <TablePagination
                component="div"
                style={{ display: "flex", justifyContent: "flex-end" }}
                count={dataList.length}
                page={currentPage}
                onPageChange={(e, newPage) => {
                  setCurrentPage(newPage);
                }}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={rowsPerPageList}
                onRowsPerPageChange={(event) => {
                  setRowsPerPage(
                    parseInt(event?.target?.value ? event?.target?.value : "5")
                  );
                  setCurrentPage(0);
                }}
              />
            ) : (
              <></>
            ))}
        </div>
      )}
    </GeneralStyle>
  );
};

export default EmailTemplateList;
